import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="tw-py-4">
      <div className="tw-flex tw-items-center tw-justify-center tw-gap-6">
        <a
          className="tw-text-xs tw-text-gray-500 hover:tw-text-primary hover:tw-underline"
          href="#"
        >
          Help Center
        </a>
        <a
          className="tw-text-xs tw-text-gray-500 hover:tw-text-primary hover:tw-underline"
          href="#"
        >
          FAQ
        </a>
        <a
          className="tw-text-xs tw-text-gray-500 hover:tw-text-primary hover:tw-underline"
          href="#"
        >
          About
        </a>
      </div>
    </footer>
  );
};

export default Footer;
